import type { HTMLAttributes } from "react";
import styles from "./BrickPill.module.css";
import { cx } from "../cx";
import { IconBrick } from "../icons/Icon";

export type BrickPillProps = HTMLAttributes<HTMLSpanElement> & {
  count: number | string;
  /** glass = 이미지 위 플로팅 헤더용 */
  variant?: "neutral" | "glass";
  size?: "medium" | "small";
};

/** 보유 브릭 pill (TopNavigation·BottomSheetHeader·ChatFloatingHeader 공용). */
export function BrickPill({ count, variant = "neutral", size = "medium", className, ...rest }: BrickPillProps) {
  const n = typeof count === "number" ? count.toLocaleString("ko-KR") : count;
  return (
    <span className={cx(styles.root, styles[variant], styles[size], className)} {...rest}>
      <IconBrick size={size === "small" ? 16 : 18} />
      <span>{n}</span>
    </span>
  );
}
